// ProtectedRoute.js
import React from 'react';
import {Navigate, useLocation, useNavigate} from 'react-router-dom';

const ProtectedRoute = ({ element: Component }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const token = new URLSearchParams(location.search).get('token');
  const rememberMe = new URLSearchParams(location.search).get('rememberMe');
  const userId = new URLSearchParams(location.search).get('user');
  // console.log("xxxxx")
  // console.log(rememberMe)
  if (token) {
    if (rememberMe === true) {
      localStorage.setItem('authToken', token);
      localStorage.setItem('user', userId)
      navigate('/');
    } else {
      sessionStorage.setItem('authToken', token);
      navigate('/');
    }
  }
  // const isAuthenticated = !!sessionStorage.getItem('authToken');
  const isAuthenticated = !!sessionStorage.getItem('authToken') || !!localStorage.getItem('authToken');
  return isAuthenticated ? <Component /> : <Navigate to="/welcome" />;
};

export default ProtectedRoute;
